import React, { Component } from "react";
import PropTypes from "prop-types";
import interact from "interactjs";
import Alert from "./../../common/alert/Alert";
import EditorBox from "../editor_box/EditorBox";
import { RESIZE_SORTABLE_CONTAINER, ADD_BOX } from "../../../../common/actions";
import { isAncestorOrSibling, isBox, isSortableContainer } from "../../../../common/utils";
import IdealStudio from "../../../../core/editor/main";
import i18n from "i18next";
import "./_pluginPlaceHolder.scss";
import { ID_PREFIX_BOX, ID_PREFIX_SORTABLE_CONTAINER } from "../../../../common/constants";
import { instanceExists, releaseClick, findBox, createBox } from "../../../../common/common_tools";
import { concatSeries } from "async";

export default class PluginPlaceholder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alert: null,
      flag: false,
    };
    this.componentRef = React.createRef();
  }
  render() {
    let container =
      this.props.parentBox.sortableContainers[this.idConvert(this.props.pluginContainer)] || {};
    let className = "drg" + this.idConvert(this.props.pluginContainer);
    /* if(this.props.boxLevelSelected - this.props.parentBox.level === 1 &&
           isAncestorOrSibling(this.props.parentBox.id, this.props.boxSelected, this.props.boxes)) {
            className += " childBoxSelected";
        }*/
    container.style = container.style || {};
    return (
      <div
        ref={this.componentRef}
        style={Object.assign(
          {},
          {
            width: "100%",
            height: container.height
              ? container.height === "auto"
                ? container.height
                : container.height + "px"
              : "",

            textAlign: "center",
            boxSizing: "border-box",
            position: "relative",
            display: "table",
          },
          container.style
        )}
        id={this.idConvert(this.props.pluginContainer)}
        className={className}
      >
        {container.colDistribution ? (
          container.colDistribution.map((col, i) => {
            if (container.cols[i]) {
              return (
                <div
                  key={i}
                  style={{
                    width: col + "%",
                    height: "100%",
                    display: "table-cell",
                    verticalAlign: "top",
                  }}
                >
                  {container.cols[i].map((row, j) => {
                    return (
                      <div
                        key={j}
                        style={{ width: "100%", height: row + "%", position: "relative" }}
                        ref={(e) => {
                          if (e !== null && !this.state.flag) {
                            this.configureDropZone(
                              e,
                              ".rib, .dnd" /* + this.idConvert(this.props.pluginContainer)*/,
                              {
                                i: i,
                                j: j,
                              }
                            );
                            this.setState({ flag: true });
                          }
                        }}
                      >
                        {this.state.alert}
                        {container.children.map((idBox, index) => {
                          if (
                            this.props.boxes[idBox].col === i &&
                            this.props.boxes[idBox].row === j
                          ) {
                            return (
                              <EditorBox
                                id={idBox}
                                key={index}
                                boxes={this.props.boxes}
                                boxSelected={this.props.boxSelected}
                                boxLevelSelected={this.props.boxLevelSelected}
                                containedViewSelected={this.props.containedViewSelected}
                                pluginToolbars={this.props.pluginToolbars}
                                lastActionDispatched={this.props.lastActionDispatched}
                                markCreatorId={this.props.markCreatorId}
                                onRichMarksModalToggled={this.props.onRichMarksModalToggled}
                                addMarkShortcut={this.props.addMarkShortcut}
                                deleteMarkCreator={this.props.deleteMarkCreator}
                                onBoxSelected={this.props.onBoxSelected}
                                onBoxLevelIncreased={this.props.onBoxLevelIncreased}
                                onBoxMoved={this.props.onBoxMoved}
                                onRichMarkMoved={this.props.onRichMarkMoved}
                                onBoxResized={this.props.onBoxResized}
                                onBoxesInsideSortableReorder={
                                  this.props.onBoxesInsideSortableReorder
                                }
                                onSortableContainerResized={this.props.onSortableContainerResized}
                                onBoxAdded={this.props.onBoxAdded}
                                onToolbarUpdated={this.props.onToolbarUpdated}
                                page={this.props.page}
                                pageType={this.props.pageType}
                                marks={this.props.allMarks}
                                containedViews={this.props.containedViews}
                                onBoxDropped={this.props.onBoxDropped}
                                onRichMarkUpdated={this.props.onRichMarkUpdated}
                                onVerticallyAlignBox={this.props.onVerticallyAlignBox}
                                exercises={this.props.exercises}
                                setCorrectAnswer={this.props.setCorrectAnswer}
                                onTextEditorToggled={this.props.onTextEditorToggled}
                                isFibQuestion={
                                  this.props.isFibQuestion !== undefined && this.props.isFibQuestion
                                }
                                isDndQuestion={
                                  this.props.isDndQuestion !== undefined && this.props.isDndQuestion
                                }
                                setCorrectAnswerForFib={this.props.setCorrectAnswerForFib}
                                dndIndex={this.props.dndIndex}
                                onAddDragArea={this.props.onAddDragArea}
                                getFibAnswers={this.props.getFibAnswers}
                                onSetFibAnswer={this.props.onSetFibAnswer}
                              />
                            );
                          } else if (index === container.children.length - 1) {
                            return (
                              <span>
                                <br />
                                <br />
                              </span>
                            );
                          }
                          return null;
                        })}
                        {container.children.length === 0 ? (
                          <span>
                            <br />
                            <br />
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                    );
                  })}
                </div>
              );
            }
            return null;
          })
        ) : (
          <div />
        )}
      </div>
    );
  }
  isComplex(pluginName) {
    let plug = IdealStudio.Plugins.get(pluginName);
    return plug && (plug.getConfig().isComplex || plug.getConfig().category === "evaluation");
  }
  configureDropZone(node, selector, extraParams) {
    let alert = (msg) => {
      return (
        <Alert
          className="pageModal"
          show
          hasHeader
          backdrop={false}
          title={
            <span>
              <i
                className="material-icons"
                style={{ fontSize: "1em", marginRight: "0.35em", color: "yellow" }}
              >
                warning
              </i>
              {i18n.t("messages.alert")}
            </span>
          }
          closeButton
          onClose={() => {
            this.setState({ alert: null });
          }}
        >
          <span> {msg} </span>
        </Alert>
      );
    };
    interact(node).dropzone({
      accept: selector,
      overlap: "pointer",
      ondropactivate: (e) => {
        let pluginDraggingFromRibbonIsNotComplex =
          e.relatedTarget.className.indexOf("rib") === -1 ||
          !e.relatedTarget.getAttribute("name") ||
          !this.isComplex(e.relatedTarget.getAttribute("name"));
        let pluginDraggingFromCanvasIsNotComplex =
          e.relatedTarget.className.indexOf("rib") !== -1 ||
          (this.props.pluginToolbars[this.props.boxSelected] &&
            this.props.pluginToolbars[this.props.boxSelected].pluginId &&
            !this.isComplex(this.props.pluginToolbars[this.props.boxSelected].pluginId));
        let notYourself =
          e.relatedTarget.className.indexOf("rib") !== -1 ||
          this.props.parentBox.id !== this.props.boxSelected;

        if (
          notYourself &&
          pluginDraggingFromRibbonIsNotComplex &&
          pluginDraggingFromCanvasIsNotComplex
        ) {
          e.target.classList.add("drop-active");
        }
      },
      ondragenter: function (e) {
        e.target.classList.add("drop-target");
      },
      ondragleave: function (e) {
        e.target.classList.remove("drop-target");
      },
      ondrop: function (e) {
        e.dragEvent.stopPropagation();

        let clone = document.getElementById("clone");
        if (clone) {
          clone.parentNode.removeChild(clone);
        }

        // If element dragged is coming from PluginRibbon, create a new EditorBox
        let draggingFromRibbon = e.relatedTarget.className.indexOf("rib") !== -1;
        // Guard: a canvas drag whose source box no longer resolves (e.g. an
        // assessment answer that must not be draggable) would crash reading
        // .pluginId below — ignore such drops.
        if (!draggingFromRibbon && !this.props.pluginToolbars[this.props.boxSelected]) {
          return;
        }
        let name = draggingFromRibbon
          ? e.relatedTarget.getAttribute("name")
          : this.props.pluginToolbars[this.props.boxSelected].pluginId;
        let parent = forbidden ? this.props.parentBox.parent : this.props.parentBox.id;
        let container = forbidden
          ? this.props.parentBox.container
          : this.idConvert(this.props.pluginContainer);
        let config = IdealStudio.Plugins.get(name).getConfig();
        let forbidden = isBox(parent) && (config.isComplex || config.category === "evaluation"); // && (parent !== this.props.boxSelected);

        let initialParams = {
          parent: forbidden ? this.props.parentBox.parent : parent,
          container: forbidden ? this.props.parentBox.container : container,
          col: forbidden ? 0 : extraParams.i,
          row: forbidden ? 0 : extraParams.j,
          page: this.props.page,
          id: ID_PREFIX_BOX + Date.now(),
          position: { type: "relative", x: 0, y: 0 },
        };
        let newInd =
          initialParams.container === 0
            ? undefined
            : this.getIndex(
                this.props.boxes,
                initialParams.parent,
                initialParams.container,
                e.dragEvent.clientX,
                e.dragEvent.clientY,
                forbidden,
                this.props.parentBox.id
              );

        console.log("Drop details:", {
          draggingFromRibbon,
          container: initialParams.container,
          parent: initialParams.parent,
          newInd,
          coordinates: { x: e.dragEvent.clientX, y: e.dragEvent.clientY },
        });

        initialParams.index = newInd;
        if (draggingFromRibbon) {
          if (config.limitToOneInstance && instanceExists(config.name)) {
            this.setState({ alert: alert(i18n.t("messages.instance_limit")) });
            return;
          }
          let isSlide = this.props.parentBox.resizable;
          createBox(initialParams, name, isSlide, this.props.onBoxAdded, this.props.boxes);
        } else if (!(config.isComplex && initialParams.container === 0)) {
          let boxDragged = this.props.boxes[this.props.boxSelected];
          // If box being dragged is dropped in a different column or row, change its value
          if (this.props.parentBox.id !== this.props.boxSelected) {
            // initialParams.position = { type: 'relative', x: 0, y: 0 };

            console.log("Calling onBoxDropped with:", {
              id: boxDragged.id,
              row: initialParams.row,
              col: initialParams.col,
              parent: initialParams.parent,
              container: initialParams.container,
              oldParent: boxDragged.parent,
              oldContainer: boxDragged.container,
              position: initialParams.position,
              index: newInd,
            });

            this.props.onBoxDropped(
              boxDragged.id,
              initialParams.row,
              initialParams.col,
              initialParams.parent,
              initialParams.container,
              boxDragged.parent,
              boxDragged.container,
              initialParams.position,
              newInd
            );

            return;
          }
        }
      }.bind(this),
      ondropdeactivate: function (e) {
        e.target.classList.remove("drop-active");
        e.target.classList.remove("drop-target");
      },
    });
  }
  componentWillUnmount() {
    if (this.componentRef.current) {
      interact(this.componentRef.current).unset();
    }
    interact(".editorBoxSortableContainer").unset();
  }
  componentDidMount() {
    if (this.componentRef.current) {
      interact(this.componentRef.current).resizable({
        enabled: false, // this.props.resizable,
        edges: { left: false, right: false, bottom: true, top: false },
        onmove: (event) => {
          event.target.style.height = event.rect.height + "px";
        },
        onend: (event) => {
          // TODO Revew how to resize sortable containers
          let toolbar = this.props.pluginToolbars[this.props.parentBox.id];
          this.props.onSortableContainerResized(
            this.idConvert(this.props.pluginContainer),
            this.props.parentBox.id,
            parseInt(event.target.style.height, 10)
          );
          IdealStudio.Plugins.get(toolbar.pluginId).forceUpdate(
            toolbar.state,
            this.props.parentBox.id,
            RESIZE_SORTABLE_CONTAINER
          );
        },
      });
    }
  }

  getIndex(boxes, parent, container, x, y, forbidden, currentBox) {
    let children = boxes[parent].sortableContainers[container].children;

    if (forbidden) {
      return children.indexOf(currentBox);
    }

    if (children.length === 0) {
      return 0;
    }

    let bestIndex = 0;
    let minDistance = Infinity;
    let validElements = [];

    // Try different strategies to find the actual positioned elements
    for (let i = 0; i < children.length; i++) {
      let childElement = null;
      let rect = null;

      // Strategy 1: Direct ID lookup
      childElement = document.getElementById(children[i]);
      if (childElement) {
        rect = childElement.getBoundingClientRect();
        if (rect.width > 0 && rect.height > 0) {
          validElements.push({ index: i, element: childElement, rect });
          continue;
        }
      }

      // Strategy 2: Look for elements with ID containing the box ID
      let boxIdElements = document.querySelectorAll(`[id*="${children[i]}"]`);
      for (let elem of boxIdElements) {
        rect = elem.getBoundingClientRect();
        if (rect.width > 0 && rect.height > 0) {
          validElements.push({ index: i, element: elem, rect });
          break;
        }
      }

      // Strategy 3: Look for .editorBox elements within the container
      if (!validElements.find((v) => v.index === i)) {
        let editorBoxes = document.querySelectorAll(".editorBox");
        for (let box of editorBoxes) {
          if (box.id === children[i]) {
            rect = box.getBoundingClientRect();
            if (rect.width > 0 && rect.height > 0) {
              validElements.push({ index: i, element: box, rect });
              break;
            }
          }
        }
      }
    }

    if (validElements.length === 0) {
      return children.length;
    }

    // Calculate best insertion point based on valid elements
    for (let valid of validElements) {
      let centerX = valid.rect.left + valid.rect.width / 2;
      let distance = Math.abs(x - centerX);

      if (distance < minDistance) {
        minDistance = distance;
        bestIndex = x < centerX ? valid.index : valid.index + 1;
      }
    }

    bestIndex = Math.max(0, Math.min(bestIndex, children.length));
    return bestIndex;
  }
  idConvert(id) {
    if (isSortableContainer(id)) {
      return id;
    }
    return ID_PREFIX_SORTABLE_CONTAINER + id;
  }
}

PluginPlaceholder.propTypes = {
  /**
   * Plugins container name
   */
  pluginContainer: PropTypes.string,
  /**
   * Unique identifier of the parent box
   */
  parentBox: PropTypes.any,
  /**
   * Object containing all created boxes (by id)
   */
  boxes: PropTypes.object,
  /**
   * Current Box selected. If there isn't, -1
   */
  boxSelected: PropTypes.any,
  /**
   * Selected box level (only plugins inside plugins)
   */
  boxLevelSelected: PropTypes.any,
  /**
   * Object containing every plugin toolbar (by id)
   */
  pluginToolbars: PropTypes.object,
  /**
   * Last action dispatched in Redux
   */
  lastActionDispatched: PropTypes.any,
  /**
   * Callback for selecting a box
   */
  onBoxSelected: PropTypes.func,
  /**
   * Callback for increasing box level selected (only plugins inside plugins)
   */
  onBoxLevelIncreased: PropTypes.func,
  /**
   * Selected contained view (by ID)
   */
  containedViewSelected: PropTypes.any,
  /**
   * Callback for moving a box
   */
  onBoxMoved: PropTypes.func,
  /**
   * Callback for resizing a box
   */
  onBoxResized: PropTypes.func,
  /**
   * Callback for resizing a sortable container
   */
  onSortableContainerResized: PropTypes.func,
  /**
   * Callback for dropping a box
   */
  onBoxDropped: PropTypes.func,
  /**
   * Callback for vertically aligning boxes inside a container
   */
  onVerticallyAlignBox: PropTypes.func,
  /**
   * Callback for reordering boxes inside a container
   */
  onBoxesInsideSortableReorder: PropTypes.func,
  /**
   * Callback for toggling CKEditor
   */
  onTextEditorToggled: PropTypes.func,
  /**
   * Identifier of the box that is creating a mark
   */
  markCreatorId: PropTypes.any,
  /**
   * Callback for adding a mark shortcut
   */
  addMarkShortcut: PropTypes.func,
  /**
   * Callback for deleting mark creator overlay
   */
  deleteMarkCreator: PropTypes.func,
  /**
   * Callback for adding a box
   */
  onBoxAdded: PropTypes.func,
  /**
   *  View type
   */
  pageType: PropTypes.string,
  /**
   * Object containing all contained views (identified by its ID)
   */
  containedViews: PropTypes.object,
  /**
   *  Callback for toggling rich marks modal creator
   */
  onRichMarksModalToggled: PropTypes.func,
  /**
   * Function that updates a mark
   */
  onRichMarkUpdated: PropTypes.func,
  /**
   * Function that moves a mark
   */
  onRichMarkMoved: PropTypes.func,
  /**
   * Sets the correct answer of an exercise
   */
  setCorrectAnswer: PropTypes.func,
  /**
   * Current page
   */
  page: PropTypes.any,
  /**
   * Object containing all the marks in the course
   */
  allMarks: PropTypes.object,
  /**
   * Function that updates the toolbar of a view
   */
  onToolbarUpdated: PropTypes.func,
};
